export const baseURL = 'https://api-downloads.inteco.org/api/v1';
